import { AgeGroup, DocumentReference, FestivalUser } from "../models";
import { 
     AgeGroupService, ArrayService, AuthService, 
     ChurchService, DatabaseService, FestivalUserService 
} from "../services";

export class PageClass {

     protected currentUser: FestivalUser;
     protected actionUser: DocumentReference;
     protected ageLevelList: AgeGroup[] = [];
     protected churchList: DocumentReference[] = [];
     protected isLoading = true;
     protected today: Date = new Date();

     protected monthNames = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
     ];

     protected filterChurchKey = 'church';
     protected filterChoirCategoryKey = 'choirCategory';
     protected filterTheatreCategoryKey = 'theatreCategory';
     protected filterITCategoryKey = 'itCategory';
     protected filterResearchCategoryKey = 'researchCategory';
     
     constructor(
          protected ageGroupService: AgeGroupService,
          protected arrayService: ArrayService,
          protected authService: AuthService,
          protected churchService: ChurchService,
          protected databaseService: DatabaseService,
          protected festivalUserService: FestivalUserService) { }

     async ngOnInit() {
          await this.getCurrentUser();
          // return;
     }

     private getCurrentUser = async (): Promise<void> => {
          this.currentUser = this.festivalUserService.GetCurrentFestivalUser();
          if (!!this.currentUser) {
               await this.getAgeLevelList();
          } else {
               this.getFirebaseUser();
          }
     }

     protected loadData = async () => { 
          
     }

     private getFirebaseUser = (): void => {
          this.authService.getCurrentUser().subscribe(
               systemUser => {
                    if (!!systemUser) {
                         this.loadUser(systemUser.uid);
                    } else {
                         // What to do here??
                    }
               }
          );
     } 

     private loadUser = async (userId: string) => {
          (await this.festivalUserService.getFestivalUser(userId)).subscribe(
               currentUsers => {
                    this.festivalUserService.SetCurrentFestivalUser(currentUsers[0]);
                    this.currentUser = currentUsers[0];
                    this.getAgeLevelList();
               } 
          );
     }

     private getAgeLevelList = async ():Promise<void> => {
          this.actionUser = {
               displayName: this.currentUser.user.displayName,
               reference: this.databaseService.doc(`${this.festivalUserService.collection}/${this.currentUser.id}`).ref
          };
          
          this.ageLevelList = this.ageGroupService.getAgeLevelList();
          if (!!this.ageLevelList) {
               this.churchList = [];
               await this.getChurchList();
          } else {
               this.ageLevelList = [];
               this.loadAgeLevelList();
          }
     }

     private loadAgeLevelList = async () => {
          (await this.ageGroupService.getAgeGroups()).subscribe(
               ageGroupList => {
                    this.ageLevelList = [];
                    ageGroupList.forEach(ageGroup => { 
                         ageGroup.yearLevelList.forEach(yearLevel => {
                              this.ageLevelList.push(yearLevel); 
                         });
                    });

                    this.ageLevelList = this.ageLevelList
                         .sort(this.arrayService.orderByDisplayName);

                    this.ageGroupService.setAgeLevelList(this.ageLevelList);

                    this.getChurchList();
               } 
          );
     }

     private getChurchList = async (): Promise<void> => {
          if ( !this.currentUser.isAdmin && 
               !this.currentUser.isSportLeader && 
               !this.currentUser.isActivityLeader) {
               this.churchList = [ this.currentUser.church ];
               this.loadData();
          } else {
               this.churchList = this.churchService.getChurchList();
               if (!!this.churchList) {
                    this.loadData();
               } else {
                    this.churchList = [];
                    await this.loadChurchList();
               }
          }
     }

     private loadChurchList = async () => {
          this.churchService.getChurches().subscribe(churchList => {
               this.churchList = [];
               churchList.forEach(church => {
                    this.churchList.push(
                    {
                         displayName: church.displayName,
                         reference: this.databaseService.doc(`${this.churchService.collection}/${church.id}`).ref
                    });
               });

               this.churchList = this.churchList.sort(this.arrayService.orderByDisplayName);

               this.churchService.setChurchList(this.churchList);

               this.loadData();
          });
     }

     protected isPastDateString = (dateString: string): boolean => {
          const beginOfToday = new Date().setHours(0,0,0,0);
          return new Date(dateString).setHours(0,0,0,0) < beginOfToday;
     }

     protected isPastDate = (date: Date | string): boolean => {
          return !date ? false : this.isPastDateString(date.toString());
     }
}